import React, { useEffect, useState } from 'react'
import AccountManager from './AccountManagerForm';
import { Card, Modal } from 'react-bootstrap';
import { allAccountManagers, updateManager } from './api';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import './Managers.css';
import Loader from 'src/components/Dashboard/common/Loader';

const Managers = () => {
    const [rowData, setRowData] = useState([]);
    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [reload, setReload] = useState(true);
    const [loader, setLoader] = useState(false);

    const defaultColDef = {
        sortable: true,
        resizable: false,
        filter: true,
        flex: 1,
        minWidth: 200,
        minHeight: 200,
        suppressMovable: true,
        cellStyle: { textAlign: 'center' }
    };

    // if we had column groups, we could provide default group items here
    const defaultColGroupDef = { minHeight: 200, };

    const onGridReady = (params) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    useEffect(() => {
        const fetchManagers = async () => {
            if (reload) {
                setLoader(true)
                try {
                    const resp = await allAccountManagers();
                    let filtered = resp || [];
                    const currentRole = sessionStorage.getItem('userRole');
                    if (currentRole === 'SubAdmin') {
                        filtered = filtered.filter(user =>
                            Array.isArray(user.groups) && user.groups.includes('AccountManager')
                        );
                    }

                    setRowData(filtered)
                } catch (error) {
                    console.error("Error fetching account managers");
                    setRowData([])
                } finally {
                    setLoader(false)
                    setReload(false)
                }
            }
        }

        fetchManagers()
    }, [reload])

    return (
        <>
            <Loader show={loader} />
            <AccountManager setReload={setReload} />

            <Card className='docg-card mt-4'>
                <Card.Header className="customCardHeader">
                    <Card.Title className="customCardTitle">All Account Managers</Card.Title>
                </Card.Header>
                <Card.Body className="docg-card-body">
                    <div className="ag-theme-alpine" style={{ height: "100%", width: "100%", textAlign: "center" }}>
                        <AgGridReact
                            rowData={rowData}
                            defaultColDef={defaultColDef}
                            rowHeight={60}
                            frameworkComponents={{
                                actionCellRender: (params) => (<ActionButton params={params} setReload={setReload} setLoader={setLoader} />),
                            }}
                            // enableRangeSelection={true}
                            // paginationPageSize={displayRecords}
                            defaultColGroupDef={defaultColGroupDef}
                            pagination={true}
                            onGridReady={onGridReady}
                            animateRows={true}
                            suppressAggFuncInHeader={true}
                            suppressColumnVirtualisation={true}
                        >
                            <AgGridColumn
                                headerName='Name'
                                field='firstName'
                                valueGetter={(params) => params?.data?.firstName + " " + params.data?.lastName}
                                maxWidth={250}
                            >
                            </AgGridColumn>
                            <AgGridColumn
                                headerName='Phone'
                                field='phoneNumber'
                                maxWidth={150}
                            >
                            </AgGridColumn>
                            <AgGridColumn
                                headerName='Email'
                                field='email'
                                maxWidth={250}
                            >
                            </AgGridColumn>
                            <AgGridColumn
                                headerName='Group'
                                field='groups'
                                valueFormatter={(params) => params.data?.groups?.join(", ")}
                                maxWidth={300}
                            >
                            </AgGridColumn>
                            <AgGridColumn
                                headerName='Status'
                                field='status'
                                maxWidth={150}
                                cellStyle={params => ({
                                    color: params.value === 'Active' ? 'green' : 'red',
                                    fontWeight: '500'
                                })}
                            >
                            </AgGridColumn>
                            <AgGridColumn
                                headerName='Action'
                                cellRenderer="actionCellRender"
                                minWidth={150}
                            >
                            </AgGridColumn>

                        </AgGridReact>
                    </div>
                </Card.Body>
            </Card>
        </>
    )
}

export default Managers;

const ActionButton = (props) => {
    const { params, setReload, setLoader } = props;
    let { email, status } = params?.data;
    const [show, setShow] = useState(false);
    const [message, setMessage] = useState('');

    const handlePopup = (value) => {
        if (value) {
            setMessage(`Do you want to deactivate the user?`)
        } else {
            setMessage('Do you want to activate the user?')
        }
        setShow(true);
    }

    const updateUser = async () => {
        setLoader(true)
        try {
            const response = await updateManager({ email: email, activate: (status === 'Active') ? false : true })
            if (response) {
                setReload(true);
            }
        } catch (error) {
            console.error("Error updating user", error);
        } finally {
            setLoader(false)
        }
    }

    return (
        <>
            {status === 'Active' ? (
                <button
                    style={{ border: "1px solid #c06c84", borderRadius: "9px", width: "100px", fontSize: "small" }}
                    onClick={() => handlePopup(true)}
                >
                    Deactivate
                </button >
            ) : (
                <button
                    style={{ backgroundColor: " #c06c84", color: "white", borderRadius: "9px", width: "100px", fontSize: "small" }}
                    onClick={() => handlePopup(false)}>
                    Activate
                </button >
            )}

            <Modal
                show={show}
                onHide={() => setShow(false)}
                backdrop="static"
                keyboard={false}
                dialogClassName="docg-modal"
                size="md"
                centered
            >
                <Modal.Header closeButton
                    style={{
                        fontSize: "1rem", fontWeight: "500", backgroundColor: "#dee2e6",
                        color: "#6c5b7b",
                    }}
                >
                    Confirmation
                </Modal.Header>
                <Modal.Body>
                    <div style={{ fontSize: "1rem", padding: "20px 0px", textAlign: "center", fontWeight: "400" }}>
                        {message}
                    </div>
                    <div style={{
                        margin: "1rem 0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "1rem"
                    }}>
                        <button className="docg-patient-cancel-btn" onClick={() => setShow(false)}>Cancel</button>
                        <button className='docg-save-btn' onClick={updateUser}>Proceed</button>
                    </div>
                </Modal.Body>

            </Modal>
        </>
    )
}